import projects from './../assets/data/projects.json';

export default {

  state: {
    projects,
    type:    'ALL',
    project: {},
    types:   ['ALL', 'WEB', 'BANNERS', 'APPS', 'GAMES'],
  },

  setType(type) {
    this.state.type = type;
  },

  setProject(proj) {
    this.state.project = proj;
  },

};



// WEBPACK FOOTER //
// ./src/services/Stash.js